/**
 * Утилитарный класс для безопасного форматирования полей документов
 */
export class DocumentFieldFormatter {
  /**
   * Безопасно преобразует значение в строку, возвращая пустую строку для null/undefined
   * @param value - значение для преобразования
   * @param defaultValue - значение по умолчанию (по умолчанию пустая строка)
   * @returns строковое представление значения или значение по умолчанию
   */
  static safeValue(value: string | number | null | undefined, defaultValue: string = ''): string {
    if (value === null || value === undefined || value === '') {
      return defaultValue;
    }
    return String(value);
  }

  /**
   * Безопасно конкатенирует строки, пропуская пустые значения
   * @param parts - массив частей для конкатенации
   * @param separator - разделитель (по умолчанию пробел)
   * @returns объединенная строка
   */
  static safeConcatenate(parts: { value: string | number | null | undefined; prefix?: string; suffix?: string }[], separator: string = ' '): string {
    const validParts = parts
      .filter(part => part.value !== null && part.value !== undefined && part.value !== '')
      .map(part => {
        const prefix = part.prefix || '';
        const suffix = part.suffix || '';
        return `${prefix}${part.value}${suffix}`;
      });

    return validParts.join(separator);
  }

  /**
   * Безопасно форматирует шаблонную строку, заменяя плейсхолдеры
   * @param template - шаблон с плейсхолдерами вида ${key}
   * @param values - объект со значениями для замены
   * @param defaultValue - значение по умолчанию для пустых полей
   * @returns отформатированная строка
   */
  static safeTemplate(template: string, values: Record<string, string | number | null | undefined>, defaultValue: string = ''): string {
    return template.replace(/\$\{(\w+)\}/g, (match, key) => this.safeValue(values[key], defaultValue));
  }
}
